var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-4 justify-content-md-center"},[_c('b-col',{attrs:{"cols":"8"}},[_c('h3',[_vm._v("Signing Out...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }